
export class Price{
    id: number = 0;           
    descricao: string = '';
    valor: number = 0;
    descricaoValor: string = '';
    melhorOferta: boolean = false;
}
